var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 27,
    viewBox: "0 0 45 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7617 19.0964C19.7617 16.3132 21.7904 14.0361 24.27 14.0361L39.4039 14.0361C41.8834 14.0361 43.9121 16.3132 43.9121 19.0964V21.8303L19.7617 21.8303V19.0964Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48047 22.9938C1.48047 20.2107 3.5223 17.9336 6.01788 17.9336L21.2497 17.9336C23.7453 17.9336 25.7871 20.2107 25.7871 22.9938V25.7278L1.48047 25.7278L1.48047 22.9938Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6644 9.19012C19.6644 12.3796 16.987 15.0062 13.633 15.0062C10.2789 15.0062 7.60156 12.3796 7.60156 9.19012C7.60156 6.00061 10.2789 3.37402 13.633 3.37402C16.987 3.37402 19.6644 6.00061 19.6644 9.19012Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2258 6.20903C37.2258 9.05465 34.8364 11.4024 31.8375 11.4024C28.8386 11.4024 26.4492 9.05465 26.4492 6.20903C26.4492 3.36342 28.8386 1.01562 31.8375 1.01562C34.8364 1.01562 37.2258 3.36342 37.2258 6.20903Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/Friends.435b39b8099a02c4bf44eb3630caf2b9.svg";
export { ForwardRef as ReactComponent };